import React from 'react'
import classnames from 'classnames/bind'
import css from './styles.module.scss'

const cx = classnames.bind(css)

export default function CheckMark({ className, theme }) {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className={cx(css.inner, theme)}
        d="M15.7845 7.97542L10.353 13.5681L8.89179 11.818C8.24764 11.2582 7.23472 11.9105 7.69527 12.7493L9.43186 15.8047C9.70729 16.1778 10.353 16.5502 10.9971 15.8047C11.2725 15.4315 16.5205 8.81347 16.5205 8.81347C17.1654 8.06795 16.3369 7.41572 15.7845 7.97467V7.97542Z"
      />
    </svg>
  )
}
